import Component from '../core/component';
import checkPath from './utils/checkPath'
import {createBrowserHistory} from 'history/umd/history'
import React from 'react'

/**
 *
 * @param fiber
 * @return {*}
 */
function getParent(fiber) {
    try {
        if (fiber && fiber.return) {
            if (fiber.return.tag === 2 && fiber.return.stateNode instanceof RouteComponent) {
                return fiber.return.stateNode;
            }
            return getParent(fiber.return)

        }
    } catch (ex) {
        console.error(ex);
    }

    return null;
}

/**
 *
 */
class RouteComponent extends Component {

    _location = null;
    _isRoot = false;

    constructor(props, ctx) {
        super(props, ctx);
        this.location()
        if (this._isRoot) {
            this.eventNames = [
                "Router"
            ];

        }
    }


    /**
     *
     * @return {*}
     */
    location() {
        if (this._location && this._location.href === window.location.href) {
            return this._location;
        }
        let {href} = window.location;
        let location = null;
        let parent = getParent(this._reactInternalFiber);
        if (parent) {
            location = parent.location();
            let {pathname, hash, search, state} = location;
            let path = checkPath(parent.props.path);
            pathname = checkPath(pathname);
            pathname = pathname.substring(path.length - 1);
            this._location = {pathname, hash, search, state, href};
        } else {
            if (!window.appHistory) {
                this._isRoot = true;
                window.appHistory = createBrowserHistory(this.props);
                let {location} = window.appHistory;
                if (location && location.state && location.state.rollback) {
                    window.appHistory.goBack();
                }

                this.__unlisten = window.appHistory.listen((data, type) => {
                    this._emit('Router.listen', data, type);
                    //this.forceUpdate();
                })
            }
            this._location = window.appHistory.location;
            this._location.href = href;
            this._location.length = window.appHistory.length

        }
        // console.log(this._location);
        return this._location;
    }
}

export default RouteComponent;
